import React from "react";
import { FormControl, FormLabel, Select, Skeleton } from "@chakra-ui/react";

export const FormSelect = ({
  label,
  options = [],
  value,
  placeholder,
  formProps,
  selectOnChange,
  padding = { base: "0 10px 10px 0", md: "0 20px 20px 0" },
  name,
  disabled = false,
  isWorking = false,
}) => {
  return (
    <FormControl colorScheme="brand" padding={padding} {...formProps}>
      {label && <FormLabel textTransform="capitalize">{label}</FormLabel>}
      <Skeleton isLoaded={!isWorking}>
        <Select
          placeholder={placeholder}
          value={value}
          onChange={selectOnChange}
          name={name}
          disabled={disabled}
        >
          {React.Children.toArray(
            options.map((opt) => <option value={opt.value}>{opt.name}</option>)
          )}
        </Select>
      </Skeleton>
    </FormControl>
  );
};
